import { render, staticRenderFns } from "./supplierManagement.vue?vue&type=template&id=2eb0c20b&scoped=true&"
import script from "./supplierManagement.vue?vue&type=script&lang=js&"
export * from "./supplierManagement.vue?vue&type=script&lang=js&"
import style0 from "./supplierManagement.vue?vue&type=style&index=0&id=2eb0c20b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb0c20b",
  null
  
)

export default component.exports